const einDashboard = {
  einDashboard: {
    installingSince: 'Installe de l’équipement Enphase depuis',
    accountManager: 'Gestionnaire de compte',
    installationShare: 'Part d’installations Enphase',
    nps: 'Taux de recommandation net',
    viewDashboard: 'Voir le tableau de bord',
    quarterInfo: 'du Q%{quarter},%{year} (Résidentiel)',
    npsTooltip:
      'Le taux de recommandation net est un indice variant de -100 à 100 qui mesure la propension des clients de recommander les produits ou services de la société à d’autres personnes. Ce score se fonde sur les notes attribuées par vos clients sur l’application Enlighten Mobile pour vos services et n’est visible que pour Enphase et vous. La période de temps par défaut pour les données couvre les 13 derniers mois.',
    activity: 'Activité',
    sites: 'Sites',
    batteries: 'Batteries',
    acb: 'ACB',
    certifications: 'Certifications',
    community: 'Communauté',
    storage: 'Sites de stockage',
    lastInstalledLabel: 'installés au cours des 12 derniers mois',
    lastCommissionedLabel: 'mis en service au cours des 12 derniers mois',
    viewDetails: 'Voir les détails',
    seeReviews: 'Voir les critiques',
    viewCommunity: 'Voir la communauté',
    certificateLabel: '%{count} sur %{totalCount} certifications terminées',
    networkLabel: {
      one: '%{count} message, dernier message : %{postDate}',
      other: '%{count} messages, dernier message : %{postDate}'
    },
    requestProductAccess: 'Demande d’accès au produit',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Assistance aux permis',
    sgip: 'Assistance SGIP',
    learnMore: 'En savoir plus',
    aboutProduct: 'à propos du produit',
    betaReleaseDate: 'Date de la sortie bêta',
    requestEarlyAccess: 'Demande d’accès anticipé',
    viewAllProduct: 'Voir tous les produits',
    signUp: "M'inscrire",
    betaReleaseLabel: 'à toutes les sorties bêta de produits',
    financing: 'Soutien financier',
    digitalPlatform: 'Plateforme numérique',
    lpp: 'LPP',
    requestedText: 'Demande envoyée pour un accès anticipé',
    grantedText: 'Accès bêta accordé',
    products: 'Produits',
    ratingsReviews: 'Notations et critiques',
    reviews: 'Critiques',
    otherReviews: 'Autres critiques',
    updateDetails: 'Mettre à jour les détails',
    totalSavings: 'Économies totales',
    inLastYear: 'Au cours des 12 derniers mois',
    viewBreakdown: 'Voir la répartition',
    leadsReceived: 'Prospects reçus',
    leadsClosure: 'Conclusion des prospects',
    leadsWon: 'Prospects gagnés',
    creditAvailable: 'Crédit disponible',
    buyMore: 'Acheter plus',
    messageFromCeo: 'Message de notre PDG',
    communityUpdates: 'Mises à jour de la communauté',
    makeAppointments: 'Prendre des rendez-vous',
    applicableText: 'Applicable uniquement aux membres Platine',
    view: 'Voir',
    downloadAll: 'Tout télécharger',
    promoteText: 'Promouvoir votre société avec des badges et des logos\u200b',
    asOfText: 'Au : %{date}',
    yearTotal: 'Total/an',
    redeemed: 'Utilisé',
    laborProtectionPlan: 'Programme de protection de la main-d’œuvre',
    acmPromotion: 'Promotion ACM',
    save: {
      lre_data: 'Économies du LPP',
      permit_data: 'Économies du service des permis',
      financing_data: 'Économies du service des finances',
      sgip_data: 'Économies du SGIP',
      warrantyExtension: 'Économies sur l’extension de garantie'
    },
    platinumLogo: 'Logo Platine',
    enphaseLogo: 'Logo Enphase',
    otherAssets: 'Autres actifs',
    ensembleCertificate: 'Certifié Ensemble 1.0',
    salesCertificate: 'Certifié Vente 1.0',
    marketingCertificate: 'Certifié Marketing 1.0',
    solarInstallCertificate: 'Certifié Installation solaire',
    validTill: 'Valable jusqu’au : %{date}',
    noDataAvailable: 'Aucune donnée disponible',
    notAvailable: 'Non disponible',
    notApplicable: 'Non applicable',
    title: 'Tableau de bord EIN',
    congratulationSignUp:
      'Félicitations ! Maintenant, vous aurez un accès anticipé à tous les nouveaux produits/services Enphase',
    benefits: 'Avantages',
    installationShareTooltip:
      'Le nombre indique le pourcentage d’installations Enphase que vous avez effectuées sur la totalité de vos installations',
    dataFromThirdParty: '*Selon les données reçues du tiers',
    reviewsNotAvailable: 'Aucune critique disponible',
    enphaseExecutive: 'Cadre Enphase',
    digitalAssets: 'Actifs numériques',
    leads: 'Prospects',
    tierSavings: 'Économies de niveau',
    exclusiveUpdates: 'Mises à jour exclusive',
    executiveSponsor: 'Promoteur principal',
    merchandise: 'Marchandise',
    certifiedUsers: 'Utilisateurs certifiés',
    noteAllowedOnce: 'Note : Le lien ci-dessus ne peut pas être modifié une fois qu’il a été créé',
    saveLink: `Enregistrer le lien`,
    confirm: `Confirmer`,
    copyLink: 'Copier le lien',
    allowedCharactersError:
      'Ce champ ne peut contenir que des lettres, des chiffres, des tirets et des tirets bas (500 caractères max)',
    createSystemEstimatorLink: `Créez votre lien personnalisé d’estimateur de système et partagez-le avec vos clients pour qu’ils vous fournissent des prospects. Tout prospect généré par ce lien ne sera partagé qu’avec vous sur votre Enlighten Manager.`,
    shareSystemEstimatorLink: `Partagez votre lien personnalisé d’estimateur de système avec vos clients pour qu’ils vous fournissent des prospects. Tout prospect généré par ce lien ne sera partagé qu’avec vous sur votre Enlighten Manager.`,
    systemEstimatorLink: 'Lien d’Estimateur de système',
    confirmChanges: 'Confirmer les modifications',
    confirmSELink:
      'Veuillez confirmer votre lien d’Estimateur de système. Ce lien ne pourra plus être modifié une fois enregistré.',
    copied: `Copié`,
    mySELink: 'Mon lien d’Estimateur de système',
    sdtUrlExistsError: 'This link is already in use by another installer. Please choose a different link',
    all: 'Tous',
    filterText: 'Filtrer',
    noProductAvailable: 'Aucun produit disponible'
  }
};

export default einDashboard;
